import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-action-confirm',
  templateUrl: './action-confirm.component.html',
  styleUrls: ['./action-confirm.component.scss']
})
export class ActionConfirmComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<ActionConfirmComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { message: string; },
    private snackBar: MatSnackBar
  ) { }

  message: string = this.data.message;

  ngOnInit() {
  }

  onClose() {
    this.dialog.close(false);
  }

  onCancel() {
    this.dialog.close(false);
  }

  onSubmit() {
    this.dialog.close(true);
  }

}
